import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '#/components/ui/alert-dialog';
import { Button } from '#/components/ui/button';
import { useTranslation } from '#/contexts/useTranslation';

interface Props {
  open?: boolean;
  onOpenChange?(open: boolean): void;
  onConfirm?(): void;
}
export function StakingDialogInformationConstraintDialog({
  open,
  onOpenChange,
  onConfirm,
}: Props) {
  const translationApplication = useTranslation(
    translation => translation.Application
  );
  const translation = useTranslation(
    translation => translation.EthereumStaking.StakingAction.Information
  );

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{translation.Warning.Title}</AlertDialogTitle>
          <AlertDialogDescription>
            {translation.Warning.Description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {translationApplication.Dialog.CancelButtonLabel}
          </AlertDialogCancel>
          <Button type="submit" variant="primary" asChild>
            <AlertDialogAction onClick={onConfirm}>
              {translation.ContinueButtonLabel}
            </AlertDialogAction>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
